import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AccordionService {
  private accordions: any[] = [];

  addAccordion(accordion: any) {
    this.accordions.push(accordion);
  }

  getAccordions() {
    return this.accordions;
  }

  closeAllExcept(currentAccordion: any) {
    this.accordions.forEach(accordion => {
      if (accordion !== currentAccordion) {
        accordion.isInitiallyOpen = false;
      }
    });
  }
  scrollToAccordion(accordionId: string) {
    setTimeout(() => {
      const element = document.getElementById(accordionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100); // Adjust the timeout as needed
  }
}